import { getUser } from '@/store/slices/user/selectors';
import { IWatermarkElement, WatermarkElementTypes } from '@/types/watermarks.types';
import { formatWatermarkDate, formatWatermarkTime, formatWatermarkDateTime } from './format-watermark-date';
import { store } from '@/store/main';

export const getTextForElement = (el: IWatermarkElement): string => {
  const email = getUser(store.getState())?.email;

  switch (el.type) {
    case WatermarkElementTypes.email:
      return email ?? '';
    case WatermarkElementTypes.date:
      return el.settings.text?.value || formatWatermarkDate();
    case WatermarkElementTypes.time:
      return formatWatermarkTime();
    case WatermarkElementTypes.datetime:
      return el.settings.text?.value || formatWatermarkDateTime();
    case WatermarkElementTypes.custom:
      return el.settings.text?.value ?? '';
    default:
      return '';
  }
};
